<div class="card-container mat-elevation-z1">
    <div class="card-content">
        <div *ngIf="!loading">
            <app-patient-view-component [patientview]="patient"></app-patient-view-component>
        </div>
    </div>
</div>